import { PLUS_COURSE_DETAIL } from '@/constants';
import { sendLog } from '@/lib/utils/send-log';
import type { PlusCourseRoute, PlusKoreanPosition } from '@/types';

export function sendGNBClickLog(
  button_text: string,
  button_href: string,
  page_title: string,
) {
  sendLog('hh_gnb_button_click', { button_text, button_href, page_title });
}

// 항해 플러스 메인페이지 접속 시 발생
export function sendPlusMainPageViewLog(courseType: PlusCourseRoute) {
  const logName = `hhplus_main_page_view_${courseType.toUpperCase()}`;

  sendLog(logName, {
    course_type: PLUS_COURSE_DETAIL[courseType].koreanPosition,
  });
}
// 항해 허브 메인페이지 접속 시 발생
export function sendHubPageViewLog() {
  sendLog('hh_hub_page_view', {});
}

export function sendPlusMainCurriToggleOpenLog(
  week: string,
  curriculum: string,
  courseType: PlusKoreanPosition,
) {
  const logName =
    courseType === '백엔드'
      ? 'hhplus_main_curriculumToggle_click_BE'
      : courseType === '프론트엔드'
      ? 'hhplus_main_curriculumToggle_click_FE'
      : 'hhplus_main_curriculumToggle_click_AI';

  sendLog(logName, {
    week,
    curriculum,
    course_type: courseType,
  });
}

export function sendHubHamburgerClickLog() {
  sendLog('hh_hub_hamburgerMenu_click', {});
}
